import { render, staticRenderFns } from "./NewRegister.vue?vue&type=template&id=c5d45d36&scoped=true&"
import script from "./NewRegister.vue?vue&type=script&lang=js&"
export * from "./NewRegister.vue?vue&type=script&lang=js&"
import style0 from "./NewRegister.vue?vue&type=style&index=0&id=c5d45d36&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5d45d36",
  null
  
)

export default component.exports